module.exports = __webpack_public_path__ + "img/pic_category_01_w768.c464d6b0.png";